import React from "react";
import { Link } from "react-router-dom";

const digitalItems = [
  { title: "Invoice Generator", path: "/invoice", color: "#ff7e5f" },
  { title: "Visiting and Multiple Cards", path: "/vcard", color: "#6a11cb" },
  { title: "Passport Photo Layout", path: "/photos", color: "#11998e" },
  { title: "Books PDF Composer", path: "/books", color: "#f7971e" },
  { title: "Cover Page Generator", path: "/coverpage", color: "#ee0979" },
  { title: "Kiss Cut Path", path: "/kisscut", color: "#ee0979" },
  { title: "Label PDF Kiss Cut", path: "/labelkisscut", color: "#ee0979" },
];

const offsetItems = [
  { title: "Offset Books PDF Composer", path: "/offset-books", color: "#2457a6" },
  { title: "Offset Cover Page Generator", path: "/offset-cover", color: "#7b3fb4" },
];

function ToolCard({ item }) {
  return (
    <Link to={item.path} style={{ textDecoration: "none" }}>
      <div
        style={{
          ...styles.card,
          background: `linear-gradient(135deg, ${item.color}, #ffffff33)`,
        }}
      >
        <h3 style={styles.cardText}>{item.title}</h3>
      </div>
    </Link>
  );
}

function Home() {
  return (
    <main style={styles.page}>
      <header style={styles.header}>
        <h1 style={styles.mainTitle}>📌 Main Dashboard</h1>
      </header>

      {/* TOP HALF: existing digital-printing tools */}
      <section style={styles.digitalSection} aria-labelledby="digital-heading">
        <div style={styles.sectionHeading}>
          <h2 id="digital-heading" style={styles.sectionTitle}>DIGITAL PRINTING</h2>
          <p style={styles.sectionSubtitle}>Digital sheet size: 460 × 305 mm (width × height)</p>
        </div>
        <div style={styles.grid}>
          {digitalItems.map((item) => <ToolCard key={item.path} item={item} />)}
        </div>
      </section>

      <div style={styles.divider} role="separator" aria-label="Digital and offset printing sections">
        <span style={styles.dividerLabel}>OFFSET PRINTING</span>
      </div>

      {/* BOTTOM HALF: dedicated offset-printing tools */}
      <section style={styles.offsetSection} aria-labelledby="offset-heading">
        <div style={styles.sectionHeading}>
          <h2 id="offset-heading" style={styles.sectionTitle}>OFFSET PRINTING</h2>
          <p style={styles.sectionSubtitle}>Offset sheet size: 635 × 457 mm (height × width)</p>
        </div>
        <div style={styles.grid}>
          {offsetItems.map((item) => <ToolCard key={item.path} item={item} />)}
        </div>
      </section>

      <div style={styles.divider} role="separator" aria-label="Offset and label generation sections">
        <span style={styles.dividerLabel}>LABELS</span>
      </div>

      {/* THIRD ROW: label-generation tools */}
      <section style={styles.offsetSection} aria-labelledby="label-generation-heading">
        <div style={styles.sectionHeading}>
          <h2 id="label-generation-heading" style={styles.sectionTitle}>LABELS</h2>
          <p style={styles.sectionSubtitle}>Standard, custom and personalized notebook label tools</p>
        </div>
        <div style={styles.grid}>
          <ToolCard item={{ title: "Notebook & Custom Label Generator", path: "/label-generation", color: "#0f766e" }} />
          <ToolCard item={{ title: "Personalized Notebook Labels", path: "/personalized-labels", color: "#9333ea" }} />
          <ToolCard item={{ title: "Personalized Bulk", path: "/personalized-bulk", color: "#c2410c" }} />
        </div>
      </section>
    </main>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    width: "100%",
    boxSizing: "border-box",
    padding: "28px clamp(16px, 4vw, 56px) 48px",
    background: "linear-gradient(120deg, #38a7ee 0%, #05d5df 100%)",
    fontFamily: "Segoe UI, sans-serif",
    textAlign: "center",
  },
  header: { margin: "0 auto 22px" },
  mainTitle: {
    color: "#fff", margin: 0, fontSize: "clamp(28px, 3vw, 40px)", fontWeight: 750,
  },
  digitalSection: {
    width: "100%", maxWidth: 1500, margin: "0 auto", padding: "22px 24px 26px",
    boxSizing: "border-box", borderRadius: 18,
    background: "rgba(255,255,255,0.13)",
    border: "2px solid rgba(255,255,255,0.42)",
    boxShadow: "0 8px 24px rgba(0,0,0,0.10)",
  },
  offsetSection: {
    width: "100%", maxWidth: 1500, margin: "0 auto", padding: "22px 24px 30px",
    boxSizing: "border-box", borderRadius: 18,
    background: "rgba(0,54,100,0.20)",
    border: "2px solid rgba(255,255,255,0.55)",
    boxShadow: "0 8px 24px rgba(0,0,0,0.14)",
  },
  sectionHeading: { marginBottom: 18 },
  sectionTitle: {
    color: "#fff", fontSize: "clamp(22px, 2.2vw, 30px)", margin: "0 0 5px",
    fontWeight: 800, letterSpacing: "0.06em",
  },
  sectionSubtitle: { color: "rgba(255,255,255,0.96)", margin: 0, fontSize: 14, fontWeight: 500 },
  grid: {
    display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 250px), 1fr))",
    gap: 18, width: "100%", margin: "0 auto",
  },
  card: {
    minHeight: 88, padding: "20px 18px", borderRadius: 15, color: "#fff",
    boxShadow: "0 8px 20px rgba(0,0,0,0.18)", cursor: "pointer",
    display: "flex", alignItems: "center", justifyContent: "center", boxSizing: "border-box",
  },
  cardText: { margin: 0, fontSize: 18, fontWeight: 650, color: "#fff" },
  divider: {
    height: 3, maxWidth: 1500, margin: "24px auto", borderRadius: 3,
    background: "rgba(255,255,255,0.75)", position: "relative",
  },
  dividerLabel: {
    position: "relative", top: -13, display: "inline-block", padding: "3px 18px",
    borderRadius: 20, background: "#087fba", color: "#fff", fontSize: 12,
    fontWeight: 800, letterSpacing: "0.12em",
  },
};

export default Home;
